export const Clients_Data = [
  {
    id: 1,
    compNumber: "0831",
    compName: "coral",
    // compName: "localhost:8080",
    ssoUatUrl:
      "https://securet.hibbertgroup.com/sso/sp/startSSO.ping?PartnerIdpId=https%3A%2F%2Fpingfed-ut.merck.com%2Fsaml2%2Fidp",
    ssoProdUrl:
      "https://securep.hibbertgroup.com/sso/sp/startSSO.ping?PartnerIdpId=https%3A%2F%2Fpingfed.merck.com%2Fsaml2%2Fidp",
    isSsoClient: true,
  },
  {
    id: 2,
    compNumber: "1110",
    compName: "biah",
    ssoUatUrl:
      "https://securet.hibbertgroup.com/sso/sp/startSSO.ping?PartnerIdpId=https%3A%2F%2Fsts.windows.net%2Fe1f8af86-ee95-4718-bd0d-375b37366c83%2F",
    ssoProdUrl:
      "https://securep.hibbertgroup.com/sso/sp/startSSO.ping?PartnerIdpId=https%3A%2F%2Fsts.windows.net%2Fe1f8af86-ee95-4718-bd0d-375b37366c83%2F",
    isSsoClient: true,
  },

  {
    id: 3,
    compNumber: "1305",
    compName: "avadel",
    ssoUatUrl:
      "https://securet.hibbertgroup.com/sso/sp/startSSO.ping?PartnerIdpId=https%3A%2F%2Fsts.windows.net%2F09591a12-d0fa-42a5-bd12-b40929f9cb67%2F",
    ssoProdUrl:
      "https://securep.hibbertgroup.com/sso/sp/startSSO.ping?PartnerIdpId=https%3A%2F%2Fsts.windows.net%2F09591a12-d0fa-42a5-bd12-b40929f9cb67%2F",
    isSsoClient: true,
  },
  {
    id: 4,
    compNumber: "1315",
    compName: "lantheus",
    ssoUatUrl:
      "https://securet.hibbertgroup.com/sso/sp/startSSO.ping?PartnerIdpId=http%3A%2F%2Fwww.okta.com%2Fexk235kzzhgFCZTyd0h8",
    ssoProdUrl:
      "https://securep.hibbertgroup.com/sso/sp/startSSO.ping?PartnerIdpId=http%3A%2F%2Fwww.okta.com%2Fexk1604o1xhY42yZB358",
    isSsoClient: true,
  },
  {
    id: 5,
    compNumber: "1317",
    compName: "eisai",
    ssoUatUrl:
      "https://securet.hibbertgroup.com/sso/sp/startSSO.ping?PartnerIdpId=https%3A%2F%2Fsts.windows.net%2F013327ea-41e9-4430-8dfa-cbb90ba7b1fa%2F",
    ssoProdUrl:
      "https://securep.hibbertgroup.com/sso/sp/startSSO.ping?PartnerIdpId=https%3A%2F%2Fsts.windows.net%2F013327ea-41e9-4430-8dfa-cbb90ba7b1fa%2F",
    isSsoClient: true,
  },
  {
    id: 6,
    compNumber: "1287",
    compName: "prisonfellowship",
    ssoUatUrl:
      "https://securet.hibbertgroup.com/sso/sp/startSSO.ping?PartnerIdpId=https%3A%2F%2Fsts.windows.net%2F228e4d92-01f0-4378-a468-d14fe54de509%2F",
    ssoProdUrl:
      "https://securep.hibbertgroup.com/sso/sp/startSSO.ping?PartnerIdpId=https%3A%2F%2Fsts.windows.net%2F228e4d92-01f0-4378-a468-d14fe54de509%2F",
    isSsoClient: true,
  }
];
